import type { ReactNode } from 'react';
import { useMemo, useState } from 'react';
import {
  type PageSidebarSlot,
  PageContentTopContext,
  PageLayoutContext,
  PageLayoutSlotContext,
} from './context';

type Props = {
  children: ReactNode;
};
export default function PageLayoutProvider({ children }: Props) {
  const [pageHeaderSlot, setPageHeaderSlot] = useState<ReactNode>(null);
  const [pageSidebarSlot, setPageSidebarSlot] = useState<PageSidebarSlot | null>(
    null,
  );
  const [pageContentTop, setPageContentTop] = useState(0);

  // Setters are stable, so keep the actions object stable too — otherwise every
  // `usePageSidebarSlot` / `usePageHeaderSlot` caller re-renders on each slot or
  // geometry change.
  const actions = useMemo(
    () => ({ setPageHeaderSlot, setPageSidebarSlot, setPageContentTop }),
    [],
  );

  return (
    <PageLayoutContext value={actions}>
      <PageLayoutSlotContext value={{ pageHeaderSlot, pageSidebarSlot }}>
        <PageContentTopContext value={pageContentTop}>
          {children}
        </PageContentTopContext>
      </PageLayoutSlotContext>
    </PageLayoutContext>
  );
}
